export default String.raw`
.cart-container {
    .cart {
        padding: 24px 16px;
        &__popup-box {
            padding: 24px;
        }
        &__info-bar {
            flex-wrap: wrap;
        }
        &__header-wrapper {
            .cart__action-btn {
                border-radius: 5px;
                border: 2px solid $primaryColor;
                padding: 8px;
                svg {
                    margin-right: 0;
                }
                span {
                    display: none;
                }
                &:last-of-type {
                    margin-right: 0;
                }
                &:disabled {
                    border-color: #D5D5D5;
                }
            }
        }
        &__products {
            &-expanded {
                height: auto;
                overflow: auto;
                .cart-row {
                    padding-left: 20px;
                }
            }
        }
        &__options {
            margin: 24px 0;
            &.first-step {
                grid-template-columns: 100%;
                grid-template-rows: repeat(3, auto);

                .cart__loyalty-info {
                    margin-bottom: 24px;   
                }

                .cart__summary {
                    grid-column: 1;
                    grid-row: 2;
                }
                .cart__next-btn {
                    grid-column: 1;
                    grid-row: 3;
                }
                .cart__pay-with-points {
                    margin: 8px 0 16px 0;
                }
            }
            &.third-step {
                grid-template-columns: 100%;
                .cart__summary {
                    grid-column: 1;
                    grid-row: 2;
                    display: flex;
                    flex-direction: column;
                    &-row:first-child {
                        padding-top: 24px;
                    }
                    &.cart-hide-summary {
                        .cart__summary-row:first-child {
                            display: flex;
                        }
                    }
                }
            }
        }
        &__summary {
            grid-column: 1;
        }
        &__next-btn {
            grid-row: 2;
            grid-column: 1;
        }
        &__back-btn {
            grid-row: 3;
            margin: 10px auto 0;
        }
        &__second-step {
            flex-direction: column;
            align-items: center;
            .login-container {
                margin-right: 0;
                margin-bottom: 32px;
                max-width: 588px;
                width: 100%;
            }
        }
        &__order-button {
            max-width: 300px;
            align-self: center;
        }
        &.thank-you-content {
            padding: 24px 16px;
        }
        &__redirect-btn svg.right-icon {
            fill: #FFF;
        }
        &__empty {
            &-icon {
                width: 32px;
                height: 32px;
                margin-right: 16px;
            }
            &-text {
                font-size: 18px;
            }
        }
    }
    .form__wrapper.first-short > .form__input-wrapper {
        width: 49%;
        &:first-child {
            width: 49%;
        }
    }
}

.cart-header {
    padding: 16px;
    grid-template-columns: auto 1fr;
    gap: 5%;

    &__steps {
        &-separator {
            margin: 0 auto 20px;
        }
    }
    &__logo {
        margin-right: unset;
        max-width: 100px;

        img {
            max-width: 100%;
            object-fit: contain;
        }
    }
    &__step {
        &-text {
            font-size: 10px;
        }
        &-icon {
            width: 24px;
            height: 24px;
            font-size: 14px;
            svg {
                width: 16px;
                height: 16px;
            }
        }
    }
}

.cart-footer {
    padding: 16px 32px 32px;
}

.cart-account-box {
    max-width: 588px;
    width: 100%;
    &__btn.secondary-btn {
        margin-top: 16px;
    }
}

.cart-data-section.last {
    border-bottom: 1px solid #D5D5D5;
}

.cart-row {
    display: grid;
    justify-content: space-between;
    align-items: start;
    grid-template-columns: 50% 50%;
    grid-template-rows: repeat(3, auto);
    padding: 16px 0;

    &__number, &__total-price, &__currency {
        display: none;
    }

    &__deposit-price {
        width: auto;
        text-align: right;
        padding-right: 0;
        margin-top: 16px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .deposit {
            display: flex;
            gap: 4px;
            &__unit {
                display: flex;
                gap: 4px;
                margin-top: 2px;
                font-size: 12px;
                line-height: 16px;
            }
        }
    }

    &__product {
        width: 100%;
        grid-row: 1;
        grid-column: 1 / 3;
        margin-bottom: 16px;

        .cart-additional-info__title {
            display: none;
        }

        &-info {
            .loyalty-info {
                display: flex;
                align-items: center;
                gap: 4px;
                svg {
                    fill: $primaryColorFont;
                }
            }
        }

        &-name {
            width: 90%;
        }
    }

    &__price {
        width: 100%;
        grid-row: 2;
        grid-column: 1;
        text-align: left;
        margin-bottom: 16px;
        .cart-small-price {
            font-size: 12px;
        }
        .cart-bold-price {
            font-weight: 600;
        }
    }

    &__quantity {
        width: 100%;
        grid-row: 3;
        grid-column: 1;
    }

    &__additional {
        grid-row: 2;
        grid-column: 2;
        margin-bottom: 16px;
        font-size: 12px;
    }

    &__value {
        width: 100%;
        grid-row: 3;
        grid-column: 2;
        text-align: left;
        .cart-small-price {
            font-size: 10px;
            font-weight: 500;
            color: #767676;
        }
        .cart-bold-price {
            font-weight: 500;
        }
    }

    &__options {
        width: 100%;
        grid-row: 1;
        grid-column: 2;
        align-self: flex-start;
        & > * {
            display: none;
        }
        &-deleter {
            display: block;
        }
    }

    &.header-row {
        display: none;
    }

    &__expandable {
        display: none !important;
    }
}

.cart-additional-info {
    flex-direction: row;
    align-items: center;
    margin-right: 0;
    &__title {
        margin-right: 6px;
        margin-bottom: 0;
    }
}

.cart-addresses-list {
    &__item {
        &-columns {
            width: min-content;
        }
        &-default {
            max-width: 80px;
            white-space: normal;
        }
        &-text > div:first-child {
            margin-right: 0;
        }
    }
}

.cart-delivery-item {
    grid-template-rows: repeat(4, auto);
    &__price-text {
        grid-column: 1;
        grid-row: 3;
        justify-content: flex-start;
        margin-top: 14px;
    }
    &__date {
        grid-row: 4;
        margin-left: 0;
        &.info {
            text-align: left;
        }
    }
}

.thank-you {
    &__column {
        margin-bottom: 24px;
    }
    &__box {
        padding: 16px 24px;
        flex-direction: column;
        &-column {
            &:first-child {
                margin-right: 0;
            }

            .cart__loyalty-info {
                margin-top: 24px;
            }
        }
    }
}

.cart-hide-on-desktop {
    display: block;
}

span.cart-hide-on-desktop {
    display: inline-block;
}

.cart-hide-on-mobile {
    display: none;
}

.cart-recommendations {
    padding: 32px 0;
    &__title {
        padding: 0 32px;
    }
    &::after, &::before {
        width: 32px;
    }
}

.cart-recommendations-item {
    width: calc(100% / 1.5);
    &__slider-prev {
        left: 37px;
    }
    &__slider-next {
        right: 37px;
    }
}
`